import { select, call, takeLatest } from 'redux-saga/effects';

import { ProgramBookDownloadActions } from '../constants';
import { ProgramBookDownloadApi } from 'src/services/end-points';
import { StoreState } from '../reducers';
import { PaginationService } from '../../services/api-handlers/pagination';
import {
    DeleteProgramBookDownloadAction,
    GetProgramBookDownloadAction,
    GetProgramBookDownloadsAction,
    PersistProgramBookDownloadAction,
} from '../actions/programBookDownload-actions';
import {
    handleError,
    resolveApiCall,
    ResolverApiFailure,
    ResolverApiSuccess,
} from '../../services/api-handlers/api-resolver';
import { groupProgramBookDownload } from '../../helpers/programBookDownload/programBookDownload';
import sortingService from 'src/services/sorting';
import { toast } from 'react-toastify';
import _ from 'lodash';

function* handleFetchProgramBookDownloads(action: GetProgramBookDownloadsAction) {
    const oldData = yield select((state: StoreState) => state.programBookDownloads.data);
    const { filters, sorting, page, itemsPerPage } = action.payload;

    let filterProps: any = { ...filters };

    if (filterProps?.dateFrom) {
        filterProps = {
            ...filters,
            ...filterProps?.dateFrom,
        };
        delete filterProps.dateFrom;
    }
    let sortObj = { ...sorting };
    if (_.isEmpty(sortObj)) {
        sortObj = { dateFrom: 'desc' };
    }
    yield PaginationService.setPageSize(itemsPerPage).resolveApiCall(action, page, oldData, () =>
        ProgramBookDownloadApi.getProgramBookDownloads({
            ...filterProps,
            ...sortingService.makeOrderSymfony(sortObj),
            page,
            itemsPerPage,
            pagination: itemsPerPage === -1 ? 0 : 1,
        }),
    );
}

function* handleFetchProgramBookDownload(action: GetProgramBookDownloadAction) {
    const {
        payload: { id },
    } = action;

    yield resolveApiCall(action, () => ProgramBookDownloadApi.getProgramBookDownload(id));
}

function* handleDeleteProgramBookDownload(action: DeleteProgramBookDownloadAction) {
    const {
        payload: { id, onSuccess, onError },
    } = action;

    yield resolveApiCall(
        action,
        () => ProgramBookDownloadApi.deleteProgramBookDownload(id),
        function () {
            if (onSuccess) {
                onSuccess();
            }
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (onError) {
                    onError(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handlePersistProgramBookDownload(action: PersistProgramBookDownloadAction) {
    const { payload } = action;
    const { data, callbacks } = payload;
    const dataDownload = groupProgramBookDownload(data);
    yield resolveApiCall(
        action,
        () => ProgramBookDownloadApi.createProgramBookDownload(dataDownload),
        function* (data: ResolverApiSuccess) {
            toast.success(`Download was successfully created.`);
            yield call(callbacks.resolve);
            /*if (restData.month) {
                yield put(
                    getProgramBookDownloads({
                        filters: {
                            'provider.id': restData?.provider,
                            'createdAt[before]': restData.month.monthEnd,
                            'createdAt[after]': restData.month.monthStart,
                        },
                        itemsPerPage: 1200,
                        page: 1,
                    }),
                );
            } */
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (result.error && result.error.response && result.error.response.status) {
                    toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

export default function* () {
    yield takeLatest(ProgramBookDownloadActions.FETCH_PROGRAM_BOOK_DOWNLOADS, handleFetchProgramBookDownloads);
    yield takeLatest(ProgramBookDownloadActions.FETCH_PROGRAM_BOOK_DOWNLOAD, handleFetchProgramBookDownload);
    yield takeLatest(ProgramBookDownloadActions.DELETE_PROGRAM_BOOK_DOWNLOAD, handleDeleteProgramBookDownload);
    yield takeLatest(ProgramBookDownloadActions.PERSIST_PROGRAM_BOOK_DOWNLOAD, handlePersistProgramBookDownload);
}
